const getters = {
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js